import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg viewBox="0 0 33 33" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20.892 29.874h-8.78a1.5 1.5 0 000 3h8.78a1.5 1.5 0 100-3zM24.409 19.974H8.596a1.5 1.5 0 000 3H24.41a1.5 1.5 0 000-3zM27.977 10.001H5.028a1.5 1.5 0 100 3h22.949a1.5 1.5 0 100-3z" /><path d="M31.4.008H1.605a1.5 1.5 0 100 3H31.4a1.5 1.5 0 100-3z" opacity=".2" /></svg>;